import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from 'hooks/auth'
import { getQueryParameter } from 'helpers/utils'
import api, { APIError } from 'helpers/api'
import { safeLocalStorage } from 'helpers/localStorage'
import { HOME, SIGN_IN, TWO_FACTOR_SIGNIN } from 'routes'
import { SIGNIN_EMAIL_KEY } from 'app-constants'
import { redirectTo } from 'helpers/redirect'
import { clearMasqueradeToken } from 'helpers/auth'

const MicrosoftComplete: React.FC = () => {
  const { updateUser } = useAuth()
  const navigate = useNavigate()
  const [, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  const code = getQueryParameter('code')

  // The state parameter holds if a template is being used
  const state = getQueryParameter('state')

  const completeOAuth = async () => {
    const stateParam = state || undefined
    let response
    try {
      response = await api.completeMicrosoftOAuth(code!, stateParam)
    } catch (e) {
      if (e instanceof APIError) {
        setErrorMessage(e.message)
      }
      setError(true)
      console.error(e)
      return
    }
    setLoading(false)

    if (response.metadata.requireSSORedirect && response.metadata.ssoRedirectURL) {
      window.location.href = response.metadata.ssoRedirectURL
      return
    }

    if (response.metadata.require2FaRedirect) {
      clearMasqueradeToken()
      navigate(`${TWO_FACTOR_SIGNIN}?loginToken=${response.metadata.userToken}`)
      return
    } else {
      if (response.data && response.data.email) {
        safeLocalStorage.setItem(SIGNIN_EMAIL_KEY, response.data.email.toLowerCase())
      }
      clearMasqueradeToken()
      await updateUser(response.data)
      if (response.metadata.redirect) {
        navigate(response.metadata.redirect)
      } else {
        navigate(redirectTo(HOME))
      }
    }
  }

  React.useEffect(() => {
    completeOAuth()
  }, [code])

  return (
    <div className="bg-really-light-blue flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-8">
      <div className="h-fit flex flex-col bg-surface border border-divider-strong p-8 shadow-heavy rounded text-body w-[550px]">
        <h1 className="mb-12 text-2xl">Signing you into your Morta account</h1>
        {error && (
          <div>
            <p>
              {errorMessage === '' && (
                <span>
                  There was an error signing your into your account. If the problem persists contact the adminstrator on
                  your Microsoft account.
                </span>
              )}
              {errorMessage !== '' && <span>{errorMessage}</span>}
            </p>

            <br />
            <p>
              Return to <Link to={SIGN_IN}>sign in page</Link>.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default MicrosoftComplete
